/**
 * Textos (`es`) de la sección «Artículos» de la ficha del proveedor (OBR-186): qué le compramos. Tramo propio: no
 * se toca `es.ts`. Las tres lenguas deben tener las mismas claves (i18n.test.ts); ningún texto literal en las vistas.
 */

export const supplierArticlesEs = {
  'backoffice.supplierArticles': {
    // Sección del diálogo del proveedor.
    sectionTitle: 'Artículos',
    sectionHint:
      'Qué le compramos: los artículos vinculados a este proveedor, con su referencia, la unidad de compra y el precio. Solo se lee; los vínculos se editan desde la ficha del artículo o con el importador de artículo-proveedor.',
    sectionNewHint: 'Los artículos que le compremos se verán aquí una vez guardado el proveedor.',
    loadError: 'No se han podido cargar los artículos de este proveedor.',
    empty: 'Todavía no hay ningún artículo vinculado a este proveedor.',
    emptyFiltered: 'Ningún artículo coincide con la búsqueda y los filtros.',

    // Búsqueda y filtros.
    searchLabel: 'Buscar por código, nombre o referencia',
    filterStatus: 'Estado del artículo',
    statusActive: 'Solo activos',
    statusAll: 'Todos (activos y de baja)',
    statusInactive: 'Solo de baja',
    filterDefault: 'Proveedor por defecto',
    defaultAll: 'Todos',
    defaultYes: 'Solo los que tiene por defecto',
    defaultNo: 'Solo los que no tiene por defecto',
    filterUnit: 'Unidad de compra',
    unitAll: 'Todas',
    unitBulk: 'A granel (unidad base)',

    // Recuento bajo los filtros.
    summary_one: '{{count}} artículo',
    summary_other: '{{count}} artículos',
    summaryOf_one: '{{shown}} de {{count}} artículo',
    summaryOf_other: '{{shown}} de {{count}} artículos',
    hiddenInactive_one: '{{count}} artículo de baja oculto',
    hiddenInactive_other: '{{count}} artículos de baja ocultos',

    // Columnas de la lista.
    colCode: 'Código',
    colArticle: 'Artículo',
    colRef: 'Referencia del proveedor',
    colUnit: 'Unidad de compra',
    colPrice: 'Precio de compra',
    colDefault: 'Por defecto',
    colStatus: 'Estado',

    // Celdas.
    badgeDefault: 'Por defecto',
    badgeActive: 'Activo',
    badgeInactive: 'Baja',
    articleUnavailable: 'Artículo no disponible',
    unitUnavailable: 'Unidad no disponible',
    formatEquivalence: '1 {{unit}} = {{quantity}} {{base}}',
    formatBulk: 'A granel',
    pricePerUnit: '{{price}} €/{{unit}}',
    priceNoUnit: '{{price}} €',
    openArticleHint: 'Abre la ficha de «{{name}}» en una pestaña nueva',

    // Exportación a Excel.
    exportExcel: 'Exportar a Excel',
    exportBusy: 'Generando el Excel…',
    exportError: 'No se ha podido generar el Excel. Vuelve a intentarlo.',
    exportHint:
      'El Excel lleva los artículos tal como se ven ahora, con la búsqueda y los filtros aplicados.',
    excelSheetName: 'Artículos',
    excelFileName: 'articulos-{{supplier}}.xlsx',
    excelFileFallback: 'proveedor',
    excelColCode: 'Código artículo',
    excelColName: 'Artículo',
    excelColRef: 'Referencia del proveedor',
    excelColDescription: 'Descripción del proveedor',
    excelColUnit: 'Unidad de compra',
    excelColFormat: 'Equivalencia',
    excelColPrice: 'Precio de compra (por unidad base)',
    excelColBaseUnit: 'Unidad base',
    excelColDefault: 'Proveedor por defecto',
    excelColStatus: 'Estado del artículo',
    excelYes: 'Sí',
    excelNo: 'No',
  },
} as const;
